import { LngLatBounds as MapBoxLngLatBounds } from 'mapbox-gl';
export function convertToMapBoxLngLatBounds(lngLatBounds) {
    return new MapBoxLngLatBounds(lngLatBounds.sw, lngLatBounds.ne);
}
